<template>
  <div v-if="contact && !loading">
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Edition du contact <router-link :to="{name: 'ContactVue', id: contact.pk}" v-if="contact">{{contact.first_name}} {{contact.last_name}}</router-link>
      </span>
    </sticky>
    <div class="columns is-gapless is-margin-left-on-btn-actions is-margin-right-on-btn-actions is-padding-top">
      <div class="column is-12 is-9-widescreen is-8-fullhd">
        <div class="has-bg-white is-border">
          <contact-form @submit="submit" :source="contact" :loading="loading"></contact-form>
        </div>
      </div>
    </div>
  </div>
  <spinner-round v-else :isLoading="loading"></spinner-round>
</template>

<script>
  import ContactForm from '@/components/contact/ContactForm'

  export default {
    name: 'ContactEdit',
    components: {
      ContactForm
    },
    data () {
      return {
        loading: false,
        contact: null
      }
    },
    watch: {
      '$route.params.id' () {
        this.loadContact(this.$route.params.id)
      }
    },
    methods: {
      loadContact (id) {
        this.loading = true
        this.$api.contactService.getOne(id).then(r => {
          this.loading = false
          this.contact = r.data
        }).catch(r => {
          this.loading = false
        })
      },
      submit (contact) {
        this.loading = true
        this.$api.contactService.put(contact.pk, contact).then(r => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Le contact a bien été mis à jour'
          })
          this.$router.goBack(this.$route)
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du contact.'
          })
        })
      }
    },
    created () {
      this.loadContact(this.$route.params.id)
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/contact/ContactEdit.vue